import {Col, Modal} from "react-bootstrap";
import React, {Component} from 'react';
import './modal.scss';

class InvoiceFilterModal extends Component {

    render() {
        return (
            <Modal
                animation={false}
                show={this.props.show}
                onHide={this.props.onHide}
                id="invoice-filter-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Invoices Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.children}
                </Modal.Body>

                <Modal.Footer>
                    <Col xs={6} className="no-margin no-padding text-left">
                        <button type="button" onClick={this.props.clearFiltersButton} className="btn btn-default">Clear
                            Filters
                        </button>
                    </Col>
                    <Col xs={6} className="no-margin no-padding">
                        <button type="button" onClick={this.props.closeButton} className="btn btn-default"
                                data-dismiss="modal">Close
                        </button>
                        <button type="button" onClick={this.props.onHide} className="btn btn-success">Save</button>
                    </Col>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default InvoiceFilterModal;